
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import VirtualTableVue from "@/components/common/VirtualTable.vue"
import VirtualColumnVue from "@/components/common/VirtualColumn.vue"
import { computed } from '@vue/reactivity';
import { ThemeModule } from '@/store/modules/theme.module';
import OpenTicketReportApi from '@/api/OpenTicketReportApi';
import { getThisMonthStartTime, getThisWeekStartTime, getTodayNowTime, getTodayStartTime } from '@/utils/date.util';

export default defineComponent({
  components: {
    VirtualTableVue,
    VirtualColumnVue
  },
  setup () {
    let timer = 0
    const timeRef = ref<any>('THIS_DAY')
    const timeMap = new Map([
      ['THIS_DAY', '今日'],
      ['THIS_WEEK', '本周'],
      ['THIS_MONTH', '本月']
    ])
    const scoreRef = ref([]);
    let score = [];
    const timeFilter = computed(() => {
      return (value) => {
        return timeMap.get(value + '')
      }
    })
    const data = ref([]);
    const visible = ref<boolean>(false);
    
    const theme = computed(() => ThemeModule.themeType);

    function statisticsTicketEvaluate () {
      let startDate: string | null = null
      const endDate: string | null = getTodayNowTime()
      if (timeRef.value === 'THIS_DAY') {
        startDate = getTodayStartTime()
      } else if (timeRef.value === 'THIS_WEEK') {
        startDate = getThisWeekStartTime()
      } else if (timeRef.value === 'THIS_MONTH') {
        startDate = getThisMonthStartTime()
      }
      OpenTicketReportApi.statisticsTicketEvaluate({
        startDate,
        endDate,
        evaluateScores: score,
        page: {
          pageNumber: 1,
          pageSize: 100
        }
      }).then((res: any) => {
        data.value = res.list || []
        timer = setTimeout(() => {
          statisticsTicketEvaluate()
        }, 10000);
      })
    } 

    function setTime (status: null | 'showBusy' | 'online' | 'offline') {
      timeRef.value = status
      timer && clearTimeout(timer)
      statisticsTicketEvaluate()
    }

    function setScore () {
      score = scoreRef.value
      visible.value = false
      timer && clearTimeout(timer)
      statisticsTicketEvaluate()
    }

    function showModal () {
      scoreRef.value = score;
      visible.value = true;
    }

    onMounted(() => {
      statisticsTicketEvaluate()
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    }) 

    return {
      timeFilter,
      timeRef,
      theme,
      data,
      scoreRef,
      visible,
      setTime,
      setScore,
      showModal
    };
  }
})
